import { Component, OnInit, Inject, ViewChild, ElementRef, Input, Renderer2 } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SnackService } from '../../shared-services/snack.service';
import { BackendService } from '../../core/backend.service';
import { FormValidatorService } from '../../shared-services/form-validator.service';
import { HistoryProvider } from '../../core/browser-providers';
import { MediaService } from '../../shared-services/media.service';
import { Http } from '@angular/http';
import { NavigationService } from '../../shared-services/navigation.service';
import { NgForm, FormControl } from '@angular/forms';
import { DialogService } from '../../shared-components/modals/dialog.service';
import { CategoriaProducto } from './categoria-producto.model';
import { Observable } from 'rxjs/Observable';
import { Sugerencia } from '../sugerencia/sugerencia.model';
import { MatAutocompleteSelectedEvent, MatChipInputEvent } from '@angular/material';
import { Role } from '../../security/role/role.model';
import { ENTER } from '@angular/cdk/keycodes';
import { isNgTemplate } from '@angular/compiler';
import { CategoriaHijo } from './categoria-hijo.model';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

@Component({
  selector: 'app-categoria-producto-add-edit',
  templateUrl: './categoria-producto-add-edit.component.html',
  styleUrls: ['./categoria-producto-add-edit.component.scss']
})
export class CategoriaProductoAddEditComponent implements OnInit {

  sugerencias: Observable<Sugerencia[]>;
  _selectedSugerencias: Sugerencia[] = [];
  separatorKeysCodes: number[] = [ENTER];
  
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = false;
  @ViewChild('form') public roleForm: NgForm;
  @ViewChild('formCategoriaHijo') public categoriaHijoForm: NgForm;
  toppings = new FormControl();
  @ViewChild('fruitInput') fruitInput: ElementRef;

  validationFail = false;

  categoriaModNombreHijos: CategoriaHijo;

  item: CategoriaProducto;

  messageTitle: string;
  price: number = 0;
  validDates = [];
  maximoHasta: string;
  
  opcionesModificacion: string[];

  opcionModElegida:string;

  opcionCategoriaPadreElegida: CategoriaProducto;

  sinLimiteTiempo: Boolean = true;
  categoriaPrincipal: boolean = true;
  
  listaCategorias: CategoriaProducto[] =[];

  myFilter = (d: Date): boolean => {
    return !this.validDates[d.toISOString()];
  }

  isHD = false;
  

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private snackService: SnackService,
    private backendService: BackendService,
    private formValidatorService: FormValidatorService,
    private renderer: Renderer2,
    @Inject(HistoryProvider) private history: History,
    private http: Http,
    private mediaService: MediaService,
    private navigationService: NavigationService,
    private dialogService: DialogService,
  ) { }

  ngOnInit() {
    this.opcionesModificacion= ["Aumento","Descuento"];

    this.getSugerencias();
    
    this.route.data.subscribe(data => {
      this.item = data.user;
      this.item.description = this.item.id ? this.item.description : '';
      this.categoriaModNombreHijos = data.user;
      //this.categoriaModNombreHijos.id = this.item.id;
      //this.categoriaModNombreHijos.description= this.item.id ? this.item.description : '';
    //  this.banner.description = this.banner.id ? this.banner.description : '';
      if (!this.item.sugerencias/* && !this.banner.sugerencias*/) {
        this.item.sugerencias = [];
    //    this.banner.sugerencias = [];
      }

      //this.categoriaModNombreHijos.id = this.item.id;
      //this.categoriaModNombreHijos.description=this.item.description;
      //this.categoriaModNombreHijos.esPrincipal = false;

    });


    this.getCategorias();
    if(this.categoriaModNombreHijos.categoriaPadre){
      this.opcionCategoriaPadreElegida = this.categoriaModNombreHijos.categoriaPadre;
    }
    

    this.messageTitle = this.item.id  ? 'Edición de Categoría' : 'Alta de Categoría';
    //this.messageTitle = this.banner.id  ? 'Edición de Categoría' : 'Alta de Categoría';

    this.mediaService.isHighDefinition.subscribe(isHD => this.isHD = isHD);
    this.item.aumentoPrecio = 0;
    this.item.etiquetaModificacionPrecio = "";
  }

  async getSugerencias() {
    this.sugerencias = this.backendService.get(Sugerencia, Sugerencia.path, {});
  }

  compareFn(c1: any, c2: any): boolean {
    return c1 && c2 ? c1.id === c2.id : c1 === c2;
  }

  back() {
    this.navigationService.back();
  }

  remove(sugerencia: Sugerencia): void {

    const index = this.item.sugerencias.indexOf(sugerencia);
    //const bannerIndex = this.banner.sugerencias.indexOf(sugerencia);
    if (index >= 0) {
      this.item.sugerencias.splice(index, 1);
      //this.banner.sugerencias.splice(index, 2);
    }
    this.filter();
  }

  selected(event: MatAutocompleteSelectedEvent): void {

    const index = this.item.sugerencias.indexOf(event.option.value);
    //const bannerIndex = this.banner.sugerencias.indexOf(event.option.value);

    if (index >= 0) {
      return;
    }
    this.item.sugerencias.push(event.option.value);
    //this.banner.sugerencias.push(event.option.value);
    this.fruitInput.nativeElement.value = '';
    this.toppings.setValue(null);
    // this.renderer.invokeElementMethod(this.fruitInput.nativeElement, 'blur', []);
    this.filter();
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;
  }

  public sugerenciaSelected(sug: Sugerencia): boolean {
    for (const sugCate of this.item.sugerencias) {
      if (sug.id === sugCate.id) {
        return true;
      }
    }
    return false;
  }

  private filter() {
    this.sugerencias
    .map(r => r.filter(p => this._selectedSugerencias.indexOf(p) === 0));
  }
  async save() {
    if (this.validateForm()) {
      this.invokeSave();
    }
  }

  async saveCategoriaHijo() {
    //if (this.validateFormCategoriaHijo()) {
      if(this.opcionCategoriaPadreElegida){
        this.categoriaModNombreHijos.categoriaPadre = this.opcionCategoriaPadreElegida;
      }
      
      
      this.invokeSaveCategoriaHijo();
      
    //}
  }

  validateForm() {
    let validationsOK = false;

    // Valida el resto de los controles con sus validadores
    if (this.formValidatorService.isFormValid(this.roleForm)) {
      validationsOK = true;
      this.validationFail = false;
    } else {
      validationsOK = false;
      this.validationFail = true;
    }

    return validationsOK;
  }

  validateFormCategoriaHijo() {
    let validationsOK = false;

    // Valida el resto de los controles con sus validadores
    if (this.formValidatorService.isFormValid(this.categoriaHijoForm)) {
      validationsOK = true;
      this.validationFail = false;
    } else {
      validationsOK = false;
      this.validationFail = true;
    }

    return validationsOK;
  }

  private async invokeSave() {

    if (this.validateForm()) {
      this.ConfirmSave();
    }

    return;
  }

  private async invokeSaveCategoriaHijo() {

    //if (this.validateFormCategoriaHijo()) {
      this.confirmSaveCategoriaHijo();
    //}

    return;
  }

  async ConfirmSave() {
    this.dialogService.confirm(this.messageTitle,
    '¿Está seguro que desea guardar los cambios en la categoría ' + this.item.description/* + this.banner.description*/ +'?')
    .then( res => {
      if (res) {
        this.saveItem(res);
      }
    });
  }

  async confirmSaveCategoriaHijo() {
    this.dialogService.confirm(this.messageTitle,
    '¿Está seguro que desea guardar los cambios en la categoría ' + this.categoriaModNombreHijos.description/* + this.banner.description*/ +'?')
    .then( res => {
      if (res) {
        this.saveItemCategoriaHijo(res);
      }
    });
  }

  addFile(event: any) {
    this.item.imagen = event.target.files[0];
    const reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.item.imagen = (reader.result as string).split(',')[1];
      };
    }
  }

  addBanner(event: any) {
    this.item.banner = event.target.files[0];
    const bannerReader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      bannerReader.readAsDataURL(file);
      bannerReader.onload = () => {
        this.item.banner = (bannerReader.result as string).split(',')[1];
      };
    }
  }

  async saveItem(res) {
    if (res) {

      this.snackService.spinner(true);
      if(this.opcionModElegida == "Descuento"){
        this.item.aumentoPrecio = this.item.aumentoPrecio *-1
      }
      if (this.item.id) { // Update
        try {
          
          await await this.backendService.update(CategoriaProducto.path + this.item.id, this.item);
          this.snackService.success('Categoría editada');
          this.router.navigate(['/categorias']);
        } catch (ex) {
          this.snackService.error(ex.message);
        } finally {
          this.snackService.spinner(false);
        }
      }
        else try {
          await this.backendService.create(CategoriaProducto.path, this.item);
          this.snackService.success('Categoria creada');
          this.router.navigate(['/categorias']);
        } catch (ex) {
          this.snackService.error(ex.message);
        } finally {
          this.snackService.spinner(false);
        }
      }
    }

    async saveItemCategoriaHijo(res) {
      if (res) {
  
        this.snackService.spinner(true);
        
        if (this.categoriaModNombreHijos.id) { // Update
          try {
            
            await await this.backendService.update(CategoriaHijo.path, this.categoriaModNombreHijos);
            this.snackService.success('Categoría editada');
            this.router.navigate(['/categorias']);
          } catch (ex) {
            this.snackService.error(ex.message);
          } finally {
            this.snackService.spinner(false);
          }
        }/*
          else try {
            await this.backendService.create(CategoriaProducto.path, this.item);
            this.snackService.success('Categoria creada');
            this.router.navigate(['/categorias']);
          } catch (ex) {
            this.snackService.error(ex.message);
          } finally {
            this.snackService.spinner(false);
          }*/
        }
      }

    async getRango() {
      let i = 0 ;
      while ( i < 90) {
        this.maximoHasta = '';
        const fechaSiguiente = new Date(this.item.fechaDesde);
        fechaSiguiente.setDate(fechaSiguiente.getDate() + i);
        if (this.validDates[fechaSiguiente.toISOString()]) {
          this.maximoHasta = fechaSiguiente.toISOString();
          return;
        } else {
          i++;
        }
      }
    }

    sinLimiteFecha(){
      
      if(this.sinLimiteTiempo){
        this.item.fechaHasta = "3000-06-09T03:00:00.000Z";
        this.sinLimiteTiempo = false;
      }else{
        this.item.fechaHasta=null;
        this.sinLimiteTiempo = true;
      }
      
    }

    /*esCategoriaPrincipal(){
      
      if(!this.categoriaModNombreHijos.esPrincipal){

        //this.categoriaPrincipal = false;
      }else{
        if(this.opcionCategoriaPadreElegida){
          this.opcionCategoriaPadreElegida=null;
        }
        
        //this.categoriaPrincipal = true;
        this.categoriaModNombreHijos.esPrincipal = false
      }

      console.log(this.categoriaModNombreHijos)
      
    }*/

    async getCategorias(){
     await this.backendService.get(CategoriaProducto, CategoriaProducto.path + "activas-principales", null).toPromise().then( a =>{
      this.listaCategorias = a as CategoriaProducto[];
      })

      //this.categoriaModNombreHijos.categoriaPadre = this.listaCategorias[0].id
      
    }
  }



// WEBPACK FOOTER //
// ./src/app/productos/categoria-producto/categoria-producto-add-edit.component.ts